<template>
   <v-card flat>
    <v-card-title>GET - /api/reversepostcodelookup/{thoroughfare}/{locality}</v-card-title>
    <hr />
    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>HTTP Method:</td>
              <td>GET</td>
            </tr>
            <tr>
              <td>URL:</td>
              <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
            </tr>
            <tr>
              <td>Description:</td>
              <td>This function allows you to get a postcode based on the address. This function will work totally reverse of previous functions .It gives the response based on the request parameters.</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Request Parameters:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Parameter Name</th>
              <th class="text-left">Description</th>
              <th class="text-left">Parameter Type</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>thoroughfare</td>
              <td>thoroughfare value to get postcode</td>
              <td>path</td>
            </tr>
            <tr>
              <td>locality</td>
              <td>Locality</td>
              <td>path</td>
            </tr>
            <tr>
              <td>serialised</td>
              <td>true/false</td>
              <td>query</td>
            </tr>
            <tr>
              <td>organization</td>
              <td>Organization name</td>
              <td>query</td>
            </tr>
            <tr>
              <td>buildingNumberOrName</td>
              <td>Building name or Number query</td>
              <td>query</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-text>
      <ul>
        <li>Locality and Thoroughfare must have a minimum length of three characters.</li>
        <li>If you want to get a postcode based on address, we have to use this function.</li>
      </ul>
    </v-card-text>

    <v-card-title>Refer the JSON response for below parameter values –</v-card-title>
    <v-card-text>
      <ul>
        <li>Thoroughfare - READING BRIDGE</li>
        <li>Locality - READING</li>
        <li>Serialized – false</li>
        <li>Organization - APPNOVATION TECHNOLOGIES LTD</li>
        <li>buildingNumberOrName - READING BRIDGE HOUSE</li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code class v-html="jsonResponse" />
      </pre>
    </v-card-text>
    <br/>
  </v-card>
  
</template>

<script>
export default {
  name: "MainPage",

  data: () => ({
    url: process.env.VUE_APP_BASE_URL,
    restUrl:
      "reversepostcodelookup/{thoroughfare}/{locality}?serialised&organisation&buildingNumberOrName",
    jsonResponse: [
      {
        OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
        DepartmentName: "",
        PoBoxNumber: "",
        SubBuilding: "",
        Building: "READING BRIDGE HOUSE",
        DependentThoroughfare: "",
        Thoroughfare: "READING BRIDGE",
        DoubleDependentLocality: "",
        DependentLocality: "",
        PostTown: "READING",
        Postcode: "RG1 8LS"
      }
    ],
    orderNumber: 9
  })
};
</script>